import $ from 'jquery';
import {initContestCustomFields} from './custom-fields';
import {initWorkContentWysiwyg, initWysiwyg} from './wysiwyg';
import {showFormResponse} from "../common/json-response";
import {deleteHandler}  from '../cabinet/delete-custom-column';
import {showDependsParams} from '../cabinet/show-custom-fields-params';
import {changeColumnTypeHandler} from '../cabinet/custom-fields-columns';
import {addFieldVariantHandler}  from '../cabinet/add-custom-column-variants';

function initNewColumn(newColumnBlock) {
  const addColumnButton = newColumnBlock.querySelector('.add_column_variant');
  addColumnButton.addEventListener('click', addFieldVariantHandler);

  const columnsTypesSelects = newColumnBlock.querySelectorAll('.custom-field-column-types');
  columnsTypesSelects.forEach(function (typeSelect) {
    typeSelect.addEventListener('change', changeColumnTypeHandler);
  });

  const deleteButtons = document.querySelectorAll('.delete_custom_field_column');
  deleteButtons?.forEach(function (button) {
    button.addEventListener('click', deleteHandler);
  });
}

export default function() {
  const addColumnButtons = document.querySelectorAll('.add_field_column');
  const statusWrapper = document.querySelector('.action-status-messages');

  const addFieldVariantHandler = function (e) {
    e.preventDefault();
    const fieldUuid   = e.target.getAttribute('data-custom-field-uuid');
    const fieldFormat = e.target.getAttribute('data-custom-field-format');
    const fieldUuidAttr = '[data-custom-field-uuid="' + fieldUuid + '"]';
    const fieldFormatAttr = '[data-custom-field-format="' + fieldFormat + '"]';

    const blockSelector = '.custom_field_params' + fieldUuidAttr + fieldFormatAttr + ' .field_columns';
    const columnsBlock = document.querySelector(blockSelector);

    let url = e.target.getAttribute('data-add-url');
    url = url + '?fieldUuid=' + fieldUuid + '&fieldFormat=' + fieldFormat;

    $.ajax({
      type: "GET",
      url: url,
      dataType: 'json',
      success: function (data) {
        if (data.messages) {
          showFormResponse(data);
        } else if (data.html) {
          columnsBlock.insertAdjacentHTML('beforeEnd', data.html);
          const newColumnBlock = columnsBlock.querySelector('.column_item:last-child');
          initNewColumn(newColumnBlock);
        }
      },
      error: function (data) {
        if (data.messages) {
          showFormResponse(data);
        } else {
          const message = 'Возникла ошибка. Обратитесь пожалуйста в тех. поддержку';
          const statusMsg = document.createElement('div');
          statusMsg.classList.add(['alert']);
          statusMsg.classList.add(['alert_error']);
          statusMsg.innerHTML = message;
          statusWrapper.appendChild(statusMsg);
        }
      },
    });
  };

  addColumnButtons?.forEach(function (button) {
    button.addEventListener('click', addFieldVariantHandler);
  });
}